import { ArrowBack, Close } from '@mui/icons-material';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ELinks } from '@sharedInterfaces/globalEnums';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

interface ProfileTabHeaderProps {
    title: string;
    subtitle: string;
}

export function ProfileTabHeader({ title, subtitle }: ProfileTabHeaderProps) {
    const theme = useTheme();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).profileSettings;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3, px: 1 }}>
            <Box>
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: theme.palette.primary.main }}>
                    {title}
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    {subtitle}
                </Typography>
            </Box>

            {/* <Button
        variant="outlined"
        onClick={() => navigate(`/${ELinks.PROFILE}`)}
        startIcon={!isMobile ? <ArrowBack /> : undefined}
        sx={{ textTransform: 'none', flexShrink: 0, ml: 2 }}
      >
        {isMobile ? <Close /> : langStrings.backProfile}
      </Button> */}
        </Box>
    );
}
